export const subCategoryDeatils = {
  '59b0ed2cdae1831be084f804': 'Life',
  '59b0ed6fdae1831be084f805': 'Critical Illness',
  '59b0ed8fdae1831be084f806': 'Medical',
  '59b0ed98dae1831be084f807': 'Other',
  '5baf2af899d85c2d38c8f00f': 'Saving',
  '59b0edd8dae1831be084f808': 'Motor',
  '59b0eddfdae1831be084f809': 'Home',
  '59b0ede7dae1831be084f80a': 'Travel',
  '5b9a5bfee624cdb543a476d1': 'Maid',
  '5b9a5bfee624cdb543a476d2': 'Accident',
  '5c18ebd120ca05b7e2b32565': 'Provident Fund',
  '5c41b85a83230016450b2214': 'Mortgage'
};

export const TABULATOR_CONFIG = {
  DEFAULT_OPTIONS: {
    layout: 'fitColumns',
    responsiveLayout: false,
    movableColumns: true,
    resizableColumns: true,
    addRowPos: 'top',
    history: true,
    columnHeaderVertAlign: 'middle',
    headerSort: true,
    headerSortTristate: true,
    columnCalcs: 'bottom',
    tooltips: true,
    persistence: true,
    columnHeaderSortMulti: true
  }
};

export const emojis = { Personal: '🛡️', General: '🔒', Company: '💼' };